import { defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin(async () => {
  if (import.meta.client) {
    const { register } = await import('swiper/element')
    register()
  }
})
